import P2POrders from '../../components/P2POrders/P2POrders';

const P2POrdersPages = () => {
	return <P2POrders />;
};

export default P2POrdersPages;
